/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPieLine: {
  name: 'pie-line';
  data: string;
} = {
  name: 'pie-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.036 2.995a1 1 0 0 1-.762 1.192 8.003 8.003 0 0 0-5.82 10.48 1 1 0 0 1-1.885.666A9.985 9.985 0 0 1 2 12c0-4.784 3.358-8.78 7.845-9.767a1 1 0 0 1 1.191.762Zm3.021.184a1 1 0 0 1 1.276-.61C19.216 3.943 22 7.646 22 12a1 1 0 1 1-2 0 8.004 8.004 0 0 0-5.333-7.545 1 1 0 0 1-.61-1.276Zm6.453 11.925a1 1 0 0 1 .45 1.341A10 10 0 0 1 12 22c-2.38 0-4.57-.833-6.287-2.223a1 1 0 0 1 1.258-1.554A7.963 7.963 0 0 0 12 20a8 8 0 0 0 7.17-4.445 1 1 0 0 1 1.34-.45Z" fill="currentColor"/></svg>`,
};
